export const LoginValues = {
  email: "",
  password: "",
};

export const newsInitialValues = {
  title: "",
  description: "",
  image: "",
};
export const EmailValue = {
  email: "",
};

export const OtpValues = {
  otp1: "",
  otp2: "",
  otp3: "",
  otp4: "",
  otp5: "",
};

export const passwordValues = {
  newPassword: "",
  confirmPassword: "",
};
